import { useContext, useEffect, useState } from "react";
import { Box, Container, Grid, Paper } from "@mui/material";
import { useQuery, useQueryClient } from "react-query";
import { getMenus } from "./services/api";
import MenusList from "./modules/MenusList";
import { Categories } from "./Categories";
import { Products } from "./Products";
import { FMPageOpacityTransition } from "components/FMTransitions/PageTransitions";
import { AuthContext } from "context/AuthContext";
import { BulkLoad } from "./BulkLoad";
import { BranchOfficeSelectOnPage } from "components/BranchOfficesSelect/BranchOfficeSelect";

export default function Builder() {
  const { branchOfficeSelected } = useContext(AuthContext)
  const [dataMenus, setDataMenus] = useState(null)
  const [menuIdSelected, setMenuIdSelected] = useState(null);
  const [subcategoryIdSelected, setSubcategoryIdSelected] = useState(null);
  const [openBulkLoad, setOpenBulkLoad] = useState(false)
  const queryClient = useQueryClient()
  const { isFetching, data: dataMenusList } = useQuery('menusList', getMenus, { refetchOnWindowFocus: false })

  /*
   * Detección de selección de una nueva sucursal en el listado de sucursales
   */
  useEffect(() => {
    queryClient.invalidateQueries('menusList')
    setMenuIdSelected(null)
    //setChangeBranchOffice(true)
    //eslint-disable-next-line
  }, [branchOfficeSelected])

  useEffect(() => {
    if (dataMenusList !== undefined && dataMenusList !== null && dataMenusList !== "") {
      setDataMenus(dataMenusList.menus)
      document.addEventListener("wheel", function (event) {
        if (document.activeElement.type === "number") { document.activeElement.blur(); }
      });
    }
    //eslint-disable-next-line
  }, [dataMenusList])

  const handleMenuSelected = (id) => {
    setMenuIdSelected(id)
    setSubcategoryIdSelected(null)
  }

  const handleSubcategorySelected = (id) => { setSubcategoryIdSelected(id) }

  if (branchOfficeSelected === null) { return <BranchOfficeSelectOnPage /> }

  return (<>
    <FMPageOpacityTransition>
      {branchOfficeSelected !== null ?
        <Box component="main" style={{ marginBottom: 0 }}>
          <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
            <MenusList data={dataMenus} loading={isFetching} instanceSelected={menuIdSelected} selectInstance={handleMenuSelected} />
            {menuIdSelected !== null ?
              <Grid container spacing={1} sx={{ marginTop: 0.5 }}>
                <Grid item xs={12} md={6}>
                  <Paper sx={{ padding: 1 }}>
                    <Categories menu={menuIdSelected} subcategorySelected={handleSubcategorySelected} />
                  </Paper>
                </Grid>
                <Grid item xs={12} md={6}>
                  <Paper sx={{ padding: 1 }}>
                    {subcategoryIdSelected !== null ? <Products menu={menuIdSelected} subcategory={subcategoryIdSelected} /> : null}
                  </Paper>
                </Grid>
              </Grid>
              : null}
          </Container>
        </Box>
        : null }
    </FMPageOpacityTransition>
    <BulkLoad open={openBulkLoad} close={() => { setOpenBulkLoad(false) }} />
  </>)
}